import type { ReactNode } from "react";
import { TextInput } from "@/components/design/TextField";
import { MergeFieldWarning } from "@/components/save/MergeFieldWarning";
import { useFieldWarning } from "@/components/save/use-field-warning";
import type { ImportFieldError } from "@/lib/import-field-validation";

// Ein Kontaktfeld einer Bewerbung: mit Konto gegebenenfalls fest aus dem Profil, öffentlich immer frei. Die Warnung
// erscheint erst nach dem ersten Verlassen des Felds oder beim Absenden, mit den Regeln des Profil-Editors.
export function ContactTextField({
  idPrefix,
  field,
  label,
  value,
  locked = false,
  disabled,
  error,
  reveal,
  type,
  autoComplete,
  maxLength,
  onChange,
}: {
  idPrefix: string;
  field: string;
  label: ReactNode;
  value: string;
  locked?: boolean;
  disabled: boolean;
  error: ImportFieldError | null;
  reveal: boolean;
  type?: "text" | "email" | "tel" | "url";
  autoComplete?: string;
  maxLength?: number;
  onChange: (next: string) => void;
}) {
  const warning = useFieldWarning(error, reveal);
  return (
    <label className="block">
      <span className="smycles-field-label">{label}</span>
      <TextInput
        id={`${idPrefix}-${field}`}
        className="mt-1"
        type={type}
        autoComplete={autoComplete}
        maxLength={maxLength}
        value={value}
        disabled={locked || disabled}
        aria-invalid={warning.error ? true : undefined}
        onChange={(e) => {
          warning.onEdit();
          onChange(e.target.value);
        }}
        onBlur={warning.onBlur}
      />
      <MergeFieldWarning fieldKey={field} error={warning.error} />
    </label>
  );
}
